import { render, staticRenderFns } from "./multipleRadio.vue?vue&type=template&id=5977121a&"
import script from "./multipleRadio.vue?vue&type=script&lang=js&"
export * from "./multipleRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports